// user.js

import AWS from 'aws-sdk';
import * as AmazonCognitoIdentity from 'amazon-cognito-identity-js';

import config from '../config';
import { flattener } from '../utilities';

const async_getSession = user => {
  return new Promise((resolve, reject) => {
    user.getSession((error, session) => {
      if (error !== null) return reject(error);
      return resolve(session);
    });
  });
};

export const getSession = async (user = null) => {
  if (user === null) user = await getUser();
  if (user === null) {
    // Unauthenticated access
    AWS.config.region = config.region;
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
      IdentityPoolId: config.IdentityPoolId
    });
    return null;
  } else {
    const session = await async_getSession(user);
    AWS.config.region = config.region;
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
      IdentityPoolId: config.IdentityPoolId,
      Logins: {
        [config.login]: session.getIdToken().getJwtToken()
      }
    });
    return session;
  }
};

export const getUser = async () => {
  let userPool = new AmazonCognitoIdentity.CognitoUserPool({
    UserPoolId: config.UserPoolID,
    ClientId: config.ClientId
  });
  let user = userPool.getCurrentUser();
  if (user === null) return user;
  await getSession(user);
  return user;
};

const async_getDetails = (user, defaults) => {
  return new Promise((resolve, reject) => {
    user.getUserAttributes((err, attrs) => {
      if (err !== null) return reject(err);
      let payload = flattener(attrs, defaults);
      resolve(payload);
    });
  });
};

export const getDetails = async (user, defaults) => {
  // defaults is currently defined in apputils.js
  let details = await async_getDetails(user, defaults);
  return details;
};



// WEBPACK FOOTER //
// ./src/utils/user/user.js